import {RemoteRepository, RemoteRepositoryMock, RemoteRepositoryImpl} from './Repository';
import {
  SubscribeEmailNotificationCallback,
  SubscribeEmailNotificationCallbackUseCase,
  GetIncidentHistory,
  GetIncidentHistoryUseCase,
  GetStatus,
  GetStatusUseCase,
  SubscribeEmailNotification,
  SubscribeEmailNotificationUseCase,
  UnsubscribeEmailNotificationCallback,
  UnsubscribeEmailNotificationCallbackUseCase,
} from './UseCase';

interface UseCaseContainer {
  GetIncidentHistoryUseCase: GetIncidentHistory;
  GetStatusUseCase: GetStatus;
  SubscribeEmailNotificationCallbackUseCase: SubscribeEmailNotificationCallback;
  SubscribeEmailNotificationUseCase: SubscribeEmailNotification;
  UnsubscribeEmailNotificationCallbackUseCase: UnsubscribeEmailNotificationCallback;
}

let container: Partial<UseCaseContainer> = null;

export const useSystemModule = (): Partial<UseCaseContainer> => {
  if (container === null) {
    container = {};

    const remoteRepoImpl: RemoteRepository = new RemoteRepositoryImpl();

    container.GetIncidentHistoryUseCase = GetIncidentHistoryUseCase(remoteRepoImpl);
    container.GetStatusUseCase = GetStatusUseCase(remoteRepoImpl);
    container.SubscribeEmailNotificationCallbackUseCase =
      SubscribeEmailNotificationCallbackUseCase(remoteRepoImpl);
    container.SubscribeEmailNotificationUseCase = SubscribeEmailNotificationUseCase(remoteRepoImpl);
    container.UnsubscribeEmailNotificationCallbackUseCase =
      UnsubscribeEmailNotificationCallbackUseCase(remoteRepoImpl);
  }
  return container;
};
